import { Box, BoxProps } from '@chakra-ui/react';

type Props = {} & BoxProps;

export const FlexColumn = ({ ...props }: Props) => {
  return <Box {...props} display="flex" flexDir="column" />;
};
